import styled, { css } from 'styled-components';

import { colorUsage } from 'stylesheetB2c';

import {
  CONTROL_BAR_CLASS_NAME,
  PLAYING_CLASS_NAME,
} from './components/DesktopControls/DesktopControls';

export const VIDEO_AREA_Z_INDEX = 1;
export const VIDEO_PLAYER_CONTAINER_Z_INDEX = 10;
export const SWITCH_TO_FULLSCREEN_CONTAINER_Z_INDEX = 2;

export const Mp3KbpPlayerContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
Mp3KbpPlayerContainer.displayName = 'Mp3KbpPlayerContainer';

export const Mp3KbpPlayerVideoArea = styled.div<{ height: number; width: number }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  z-index: ${VIDEO_AREA_Z_INDEX};
  overflow: hidden;

  /* We need a class to have the correct transition */
  /* stylelint-disable-next-line selector-max-class */
  .${CONTROL_BAR_CLASS_NAME} {
    visibility: 'visible';
    opacity: 1;
    transition: opacity 0.5s;
  }

  /* We need a class to have the correct transition */
  /* stylelint-disable-next-line selector-max-class */
  &:not(:hover) .${CONTROL_BAR_CLASS_NAME}.${PLAYING_CLASS_NAME} {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s 0.5s, opacity 0.5s;
  }
`;
Mp3KbpPlayerVideoArea.displayName = 'Mp3KbpPlayerVideoArea';

export const VideoPlayerContainer = styled.div`
  width: 1px;
  height: 1px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${VIDEO_PLAYER_CONTAINER_Z_INDEX};
  background-color: transparent;
  visibility: collapse;
`;
VideoPlayerContainer.displayName = 'VideoPlayerContainer';

interface SwitchToFullscreenContainerProps {
  isFullscreenWithCustomCSS: boolean;
}

export const SwitchToFullscreenContainer = styled.div<SwitchToFullscreenContainerProps>`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ isFullscreenWithCustomCSS }) =>
    isFullscreenWithCustomCSS
      ? css`
          width: auto;
          height: auto;
          position: fixed;
          inset: 0;
          background-color: ${colorUsage.mp3KbpPlayer.fullscreenContainerBackdrop};
          z-index: ${SWITCH_TO_FULLSCREEN_CONTAINER_Z_INDEX};
        `
      : ''}
`;
SwitchToFullscreenContainer.displayName = 'SwitchToFullscreenContainer';
